import React from "react"
import ReactPlayer from "react-player"
import theme from "styles/theme"
import Modal from "components/Modal"

const VideoModal = ({ open, onRequestClose, url }) =>
  open && (
    <Modal
      onRequestClose={onRequestClose}
      css={{
        width: 1182,
        maxWidth: "calc((100vh - (2 * var(--modalPadding))) * 1.777)",
        background: theme.textGray,
      }}
    >
      <div
        css={{
          position: "relative",
          maxWidth: 1182,
          margin: "0 auto",
          paddingBottom: "56.25%",
          width: "100%",
          height: "100%",
          boxShadow: "5px 5px 15px rgba(51, 51, 51, 0.4)",
        }}
      >
        <ReactPlayer
          url={url}
          width="100%"
          height="100%"
          css={{
            position: "absolute",
            top: 0,
            left: 0,
          }}
          playing
          controls
          config={{
            youtube: {
              embedOptions: {
                playsinline: 0,
              },
            },
          }}
        />
      </div>
    </Modal>
  )

export default VideoModal
